module.exports = __webpack_public_path__ + "img/geology-earth.613c8538.png";